<template>
  <g-field :label="hasSlotDefault || skipLabel ? '' : 'Tahun'"
           class="select-tahun-ajaran" :is-horizontal="hasSlotDefault">
    <label v-if="hasSlotDefault" class="label">{{ $t('label.tahun') }}</label>
    <g-select :value="tahun" :placeholder="`Pilih tahun`"
              :disabled="disabled" @change="onChange" v-bind="$attrs">
      <option v-for="th in tahuns" :key="th" :value="th">{{ th }}</option>
    </g-select>
    <slot></slot>
  </g-field>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'annotation';
import {tahunbulans} from '../../../util/PluralVariabels';
import GSelect from "../common/select/GSelect.vue";
import GField from "../common/field/GField.vue";

@Component({
  components: {GField, GSelect}
})
export default class SelectBulanTahun extends Vue {

  @Prop({type: String})
  public tahun: string;

  @Prop({type: Boolean, default: false})
  public disabled: boolean;

  @Prop({type: Boolean, default: false})
  public skipLabel: boolean;

  public tahuns: Array<any> = tahunbulans;

  public tahunModel: string = '';

  public created() {
    this.tahunModel = (this.tahun || this.tahuns[1]).toString();
    this.$emit('update:tahun', this.tahunModel);
    this.$emit('tahun-selected', this.tahunModel);
  }

  public onChange(val) {
    this.$emit('update:tahun', val);
    this.$emit('tahun-selected', val);
  }

  public get hasSlotDefault() {
    return this.$scopedSlots.default || this.$slots.default;
  }
}
</script>

<style lang="scss">
.select-tahun-ajaran {
  .select, select {
    min-width: 200px;
    width: 100%;
  }

  &.is-horizontal {
    .field-body {
      align-items: center;

      .field {
        &:first-child {
          width: 150px;
        }

        flex: none;
      }
    }
  }
}
</style>

